module.exports = __webpack_public_path__ + "static/img/1-Sky-studio-at-Elstree.4cd3c354.jpg";